export const isNanChecker = (val: number) => {
  if (isNaN(val)) return 0
  return val
}